import { getToken, setToken, removeToken, getUserID, setUserID, setUserInfo, getUserInfo } from "@/utils/auth";
import { API_USER, API_COMM } from "@/api/config.js";
import {createApp} from 'vue'
import _ from "lodash"
// import { isApp } from "@/utils/meng";
const vm = createApp({});

const state = {
  userId:getUserID(),
  token: getToken(),
  showPermissionModal: false,
  userInfo: getUserInfo()?JSON.parse(getUserInfo()):null
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERID: (state, id) => {
    setUserID(id);
    state.userId = id;
  },
  SET_USERINFO: (state, userInfo) => {
    setUserInfo(userInfo)
    state.userInfo = userInfo?JSON.parse(userInfo):null
  }
};
 
const getters = {
  isLogin:(state)=> {
    return !!_.get(state, "token", "");
  },
};

const actions = {
  // get user info
  getInfo({ commit, state },userid) {
    return new Promise((resolve, reject) => {
      vm.axios.get(API_COMM.user_v1, userid)
        .then(response => {
          const { data } = response;

          if (!data) {
            reject("Verification failed, please Login again.");
          }

          const { user_id } = data;
          commit("SET_USERINFO", JSON.stringify(data));
          commit("SET_USERID", user_id);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  setToken({ commit }, data) {
    commit("SET_TOKEN", data);
    setToken(data); 
  },

  // user logout
  logout({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      vm.axios
        .delete(API_COMM.user_logout, { token: state.token })
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_USERID", "");
          commit("SET_USERINFO", null);
          removeToken();
          //resetRouter()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          //dispatch('tagsView/delAllViews', null, { root: true })
          resolve("ok");
          if (data !== undefined && data.callback !== undefined) {
            data.callback();
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_USERID", "");
      commit("SET_USERINFO", null);
      removeToken();
      resolve();
    });
  },
  // 许可
  permission({ state, getters, commit, dispatch }) {
    return new Promise((resolve, reject) => {
      // 如果不是在APP
      // if (!isApp()) {
      //   commit("showPermissionModal", true);
      //   return;
      // }

      resolve();
    });
  },

  tokenExpire({ commit }) {
    commit("SET_TOKEN", "");
    commit("SET_USERID", "");
    commit("SET_USERINFO", null);
    removeToken();
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
